<div *ngIf="avatars" class="mc-avatar-list mc-avatar-list-horizontal">
  <ng-container *ngFor="let avatar of avatars | slice:0:numAvatars, index as index, first as first, last as last">
    <ng-container [ngTemplateOutlet]="listItemDirective?.templateRef" [ngTemplateOutletContext]="{ $implicit: avatar, index: index, first: first, last: last }"></ng-container>
  </ng-container>

  <ng-container *ngIf="showMoreButton">
    <button *ngIf="!showMoreDirective; else showMoreTemplate" mat-icon-button class="mc-avatars-list-more-button mc-border-divider" [ngClass]="'mc-avatars-list-more-button-' + avatarSize" [matTooltip]="tooltip" (click)="onMoreClicked()">
      <mat-icon fontSet="project-titan" fontIcon="icon-meatballs"></mat-icon>
    </button>
    <ng-template #showMoreTemplate>
      <ng-container [ngTemplateOutlet]="showMoreDirective?.templateRef" [ngTemplateOutletContext]="{ $implicit: avatars }"></ng-container>
    </ng-template>
  </ng-container>
</div>